import React, { useState, useEffect, useRef } from "react";

import "./StudentCard.scss";

//Components Import
import GradeComponent from "./GradeComponent";

function StudentCard({ data, updateStudent }) {
    const [average, setAverage] = useState(0);
    const [newTag, setNewTag] = useState("");

    const grades = data.grades;
    const cardRef = useRef(null);

    useEffect(() => {
        let totalGrades = 0;
        for (let i = 0; i < grades.length; i++) {
            totalGrades += parseInt(grades[i], 10);
        }

        setAverage((totalGrades / grades.length).toFixed(3));
    }, [grades]);

    useEffect(() => {
        updateStudent(data);
    }, [data, updateStudent]);

    let handleExpand = (e) => {
        e.preventDefault();
        cardRef.current.classList.toggle("studentCard-active");
    };

    const addTag = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13 && newTag !== "" && newTag !== null) {
            if (!data.tag) {
                data.tag = [newTag];
            } else {
                data.tag.push(newTag);
            }
            setNewTag("");
        }
    };

    return (
        <div className="studentCard" ref={cardRef}>
            <img src={data.pic} alt={data.firstName} />
            <div className="details">
                <h1>
                    {data.firstName} {data.lastName}
                </h1>
                <p>Email: {data.email}</p>
                <p>Company: {data.company}</p>
                <p>Skill: {data.skill}</p>
                <p>Average: {average}%</p>

                <div className="grades">
                    {grades.map((grade, i) => (
                        <GradeComponent
                            grade={grade}
                            key={i + 1}
                            index={i + 1}
                        />
                    ))}
                </div>

                <div className="tags">
                    {data.tag &&
                        data.tag.map((t, index) => (
                            <p className="tag" key={index}>
                                {t}
                            </p>
                        ))}
                </div>

                <input
                    type="text"
                    className="addTag"
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    onKeyPress={addTag.bind(this)}
                />
            </div>
            <button className="btn">
                <svg
                    onClick={handleExpand}
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        className="line1"
                        d="M10 2.5C10 1.11929 11.1193 0 12.5 0V0C13.8807 0 15 1.11929 15 2.5V22.5C15 23.8807 13.8807 25 12.5 25V25C11.1193 25 10 23.8807 10 22.5V2.5Z"
                        fill="black"
                    />
                    <path
                        className="line2"
                        d="M2.5 15C1.11929 15 0 13.8807 0 12.5V12.5C0 11.1193 1.11929 10 2.5 10L22.5 10C23.8807 10 25 11.1193 25 12.5V12.5C25 13.8807 23.8807 15 22.5 15L2.5 15Z"
                        fill="black"
                    />
                </svg>
            </button>
        </div>
    );
}

export default StudentCard;
